module.exports = __webpack_public_path__ + "media/images/logos/slack_logo-639319034d8c94e5878f689f39c9a16c.svg";